import { render } from "./TestView.vue?vue&type=template&id=3030f8f0"
import script from "./TestView.vue?vue&type=script&lang=js"
export * from "./TestView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__